// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "4f2a7b153dad6b06d305a5d68f67f28b" + ".css";
};